import { Zap, Activity, Radio, Waves, Thermometer, Hand, Target, TrendingUp, Dumbbell, FileText } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import './Equipment.css';

const Equipment = () => {
  const whatsappUrl = 'https://wa.me/919886332528';

  const equipment = [
    {
      icon: <Zap size={40} />,
      title: 'TENS / IFT Machine',
      description: 'Transcutaneous Electrical Nerve Stimulation and Interferential Therapy for pain relief and muscle stimulation. Highly effective for chronic pain management.'
    },
    {
      icon: <Waves size={40} />,
      title: 'Ultrasound Therapy Unit',
      description: 'Deep tissue healing using high-frequency sound waves. Accelerates healing of soft tissue injuries, reduces inflammation, and relieves pain.'
    },
    {
      icon: <Radio size={40} />,
      title: 'Laser Therapy (LLLT)',
      description: 'Low-Level Laser Therapy for faster healing and pain relief. Non-invasive treatment for acute and chronic conditions.'
    },
    {
      icon: <Activity size={40} />,
      title: 'Cervical & Lumbar Traction Unit',
      description: 'Mechanical traction for spinal decompression. Effective for disc problems, sciatica, and neck/back pain relief.'
    },
    {
      icon: <Thermometer size={40} />,
      title: 'Shortwave Diathermy',
      description: 'Deep heat therapy to improve blood circulation and promote healing. Excellent for chronic muscle and joint conditions.'
    },
    {
      icon: <Thermometer size={40} />,
      title: 'Wax Bath Therapy',
      description: 'Paraffin wax treatment for arthritis and joint stiffness. Provides soothing heat therapy for hands and feet.'
    },
    {
      icon: <Target size={40} />,
      title: 'Balance Boards & Proprioception Tools',
      description: 'Advanced equipment for balance training, fall prevention, and ankle rehabilitation. Essential for elderly care and sports recovery.'
    },
    {
      icon: <TrendingUp size={40} />,
      title: 'Parallel Bars',
      description: 'Professional gait training equipment for walking rehabilitation. Crucial for post-surgery and neurological patients.'
    },
    {
      icon: <Dumbbell size={40} />,
      title: 'Exercise Rehabilitation Area',
      description: 'Fully equipped exercise zone with weights, resistance bands, therapy balls, and specialized rehab equipment.'
    },
    {
      icon: <FileText size={40} />,
      title: 'Kinesio Taping',
      description: 'Therapeutic taping techniques for muscle support, pain relief, and improved circulation during recovery.'
    }
  ];

  const equipmentImages = [
    'https://images.pexels.com/photos/30483052/pexels-photo-30483052.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    'https://images.pexels.com/photos/7772648/pexels-photo-7772648.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    'https://images.pexels.com/photos/13697729/pexels-photo-13697729.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    'https://images.unsplash.com/photo-1630226040750-d934f017f0e4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxwaHlzaW90aGVyYXB5JTIwZXF1aXBtZW50fGVufDB8fHx8MTc4MDQ3NjE3MHww&ixlib=rb-4.1.0&q=85',
    'https://images.pexels.com/photos/16571733/pexels-photo-16571733.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    'https://images.pexels.com/photos/13538710/pexels-photo-13538710.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    'https://images.unsplash.com/photo-1704455306925-1401c3012117?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxjbGluaWMlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODA0NzYxNDN8MA&ixlib=rb-4.1.0&q=85',
    'https://images.pexels.com/photos/29807423/pexels-photo-29807423.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
  ];

  return (
    <div className="equipment-page">
      <div className="page-hero">
        <div className="container">
          <h1>Panjim's Best-Equipped Physiotherapy Clinic</h1>
          <p className="page-subtitle">
            We combine expert hands-on therapy with the most advanced physiotherapy technology available in Panjim, Goa
          </p>
        </div>
      </div>

      {/* Equipment Grid */}
      <section className="section">
        <div className="container">
          <div className="equipment-grid-page">
            {equipment.map((item, index) => (
              <Card key={index} className="equipment-card-page">
                <CardContent className="equipment-content">
                  <div className="equipment-icon-page">{item.icon}</div>
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Why Equipment Matters */}
      <section className="section why-equipment">
        <div className="container">
          <div className="why-equipment-content">
            <h2>Why Equipment Matters</h2>
            <p>
              Advanced physiotherapy equipment accelerates healing, provides more effective pain relief, and delivers better treatment outcomes. At Dr. Manaz's clinic, we've invested in the latest technology to ensure you receive the most effective care possible. Our equipment, combined with our team's expertise, gives you the best chance for a complete and speedy recovery.
            </p>
          </div>
        </div>
      </section>

      {/* Photo Gallery */}
      <section className="section gallery-section">
        <div className="container">
          <div className="section-header">
            <h2>Our Clinic & Equipment</h2>
            <p>A glimpse inside Panjim's most advanced physiotherapy clinic</p>
          </div>
          <div className="gallery-grid">
            {equipmentImages.map((image, index) => (
              <div key={index} className="gallery-item">
                <img src={image} alt={`Clinic equipment ${index + 1}`} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section-dark cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Come See Our Clinic</h2>
            <p>Experience the difference that advanced equipment and expert care can make</p>
            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="btn-primary large">
              Book a Visit on WhatsApp
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Equipment;